import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

const DataGridNoRowsOverlay = () => {
    return (
        <Text size="sm" variant="regular">
            <FormattedMessage id="common_no_data_found" />
        </Text>
    );
};

export default DataGridNoRowsOverlay;
